const index = () => import('@/views/index.vue');
// const analysis = () => import('@/views/analysis/index.vue');
const statistic = () => import('@/views/statistic/index.vue');
const explore = () => import('@/views/explore/index.vue');
const download = () => import('@/views/download/index.vue');
const contact = () => import('@/views/contact/index.vue');
// const help = () => import('@/views/help/index.vue');
// const usermanage = () => import('@/views/admin/usermanage.vue');
// const rna = () => import('@/views/rna/index.vue');
// const scrna = () => import('@/views/scrna/index.vue');
// const proteome = () => import('@/views/proteome/index.vue');
// const ubiquitome = () => import('@/views/ubiquitome/index.vue');
// const metabonome = () => import('@/views/metabonome/index.vue');
// const visualization = () => import('@/views/visualization/index.vue');
export const menus = [
  {
    path: '/',
    component: index,
    name: 'index',
    meta: {
      title: 'HOME',
      ifHomePage: true,
    },
    isShow: true,
  },
  {
    path: '/statistic',
    component: statistic,
    name: 'statistic',
    meta: {
      title: 'Techniques & Statistic',
      needLogin: false,
    },
    isShow: true,
  },
  {
    path: '/explore',
    component: explore,
    name: 'explore',
    meta: {
      title: 'Explore',
      needLogin: false,
    },
    isShow: true,
  },
  // {
  //   path: '/analysis',
  //   component: analysis,
  //   name: 'analysis',
  //   meta: {
  //     title: 'ANALYSIS',
  //     needLogin: false,
  //   },
  //   isShow: true,
  // },
  {
    path: '/download',
    component: download,
    name: 'download',
    meta: {
      title: 'Download',
      needLogin: false,
    },
    isShow: true,
  },
  {
    path: '/contact',
    component: contact,
    name: 'contact',
    meta: {
      title: 'Contact',
    },
    isShow: true,
  },
  // {
  //   path: '/ubiquitome',
  //   component: ubiquitome,
  //   name: 'ubiquitome',
  //   meta: {
  //     title: 'HELP',
  //     needLogin: false,
  //   },
  //   isShow: true,
  // },
  // {
  //   path: '/metabonome',
  //   component: metabonome,
  //   name: 'metabonome',
  //   meta: {
  //     title: '代谢组',
  //     needLogin: false,
  //   },
  //   isShow: true,
  // },
  // {
  //   path: '/visualization',
  //   component: visualization,
  //   name: 'visualization',
  //   meta: {
  //     title: '可视化',
  //     needLogin: false,
  //   },
  //   isShow: true,
  // },
  
];
